import React, { PropsWithChildren, useRef } from 'react'
import { RichTextDropdown } from './RichTextDropdown'
import { RichTextButtons } from './RichTextButtons'
import RichTextLinkEditor from './RichTextLinkEditor'
import { useRichTextToolbar } from './hooks'
import './RichTextToolbarPlugin.scss'

export interface ToolbarPluginProps {
  className?: string
  disabled?: boolean
}

export const RichTextToolbarPlugin: React.FC<PropsWithChildren<ToolbarPluginProps>> = ({ children, className, disabled = false }) => {
  const { editor, formatting, undoRedo } = useRichTextToolbar()

  const portalDivRef = useRef<HTMLDivElement>(null)

  return (
    <>
      <div ref={portalDivRef}></div>
      <div className={`flex-wrap flex-md-nowrap d-flex rich-text-container ${className ?? ''}`}>
        <RichTextDropdown editor={editor} formatting={formatting} disabled={disabled} />
        <RichTextButtons formatting={formatting} undoRedo={undoRedo} disabled={disabled} />
        {portalDivRef.current && <RichTextLinkEditor editor={editor} formatting={formatting} anchorElem={portalDivRef.current} />}
      </div>
      {children}
    </>
  )
}
